import { create } from 'apisauce';
import { Ziggy } from '../ziggy';
import useNotiStack from '../hooks/useNotiStack';
import axios from 'axios';
import { errorHandlers } from './httpErrorHandlers';
import { route } from './../../../vendor/tightenco/ziggy/src/js/index';
const { routes } = Ziggy;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handles http errors based on returned error code
    for (const handler of errorHandlers) {
      const result = handler(error);
      if (result.shouldReject) {
        return Promise.reject(result.rejection);
      }
    }

    return Promise.reject(error);
  }
);

const apiSauce = create({
  axiosInstance: axios, // Force Apisauce to use this Axios instance
  headers: {
    'Content-Type': 'application/json',
  },
});

export const apiSauceFormData = create({ //headers for upload file
  axiosInstance: axios, // Force Apisauce to use this Axios instance
  headers: { 'Content-type': 'multipart/form-data' },
});

apiSauce.addResponseTransform(({ status, ok, data }) => {
  if (!ok) {
    const { error, warning } = useNotiStack();
    if (data?.message) {
      error(data.message);
    } else if (data?.error) {
      error(data.error);
    }
  }
});

apiSauceFormData.addResponseTransform(({ status, ok, data }) => {
  if (!ok) {
    const { error, warning } = useNotiStack();
    if (data?.message) {
      error(data.message);
    } else if (data?.error) {
      error(data.error);
    }
  }
});

export const handleResponse = (res) => {
  const re = /^[45]\d{2}$/;
  const success = res.ok && (res?.data?.code ? !re.test(res.data.code) : true);
  return success
    ? res.data
    : Promise.reject(res?.data || new Error(res.problem ?? 'ERROR'));
};

//tester
// export const testApi = (params) => apiSauce.get(routes.resendEmail.uri, params);
export const testApi = (params) => apiSauce.post(routes.contactUsMail.uri, params);

// Sign up
export const signUp = (params) => apiSauce.post(routes.signUpAccount.uri, params);
export const resendEmail = (params) => apiSauce.post(routes.resendEmail.uri, params);
export const validateFields = (params) => apiSauce.post(routes.validateFields.uri, params);

// Verify
export const verify = (params) => apiSauce.post(routes.checkHashLink.uri, params);

// Login
export const login = (params) => apiSauce.post(routes.login.uri, params);
export const logout = () => apiSauce.post(routes.logOut.uri);
export const updatePassword = (params) => apiSauce.post(routes.updatePassword.uri, params);
export const rendResetPassword = (params) => apiSauce.post(routes.resetPassword.uri, params);

// User Details
export const getUserDetails = (params) => apiSauce.get(routes.getUserDetails.uri, params);
export const createOrUpdateUserDetails = (params) => apiSauce.post(routes.createOrUpdateUserDetails.uri, params);
export const fetchCountries = (params) =>  apiSauce.get(routes.getCountries.uri, params);

// Categories
export const getCategories = (params) => apiSauce.get(routes.getCategories.uri, params);
export const getPinnedUsers = (params) => apiSauce.get(routes.getPinnedUsers.uri, params);
export const pinUsers = (params) => apiSauce.post(routes.pinUsers.uri, params);
export const deleteTag = (params) => apiSauce.post(routes.updateCategory.uri, params);
export const createCategory = (params) => apiSauce.post(routes.createCategory.uri, params);
export const updateCategory = (params) => apiSauce.post(routes.updateCategory.uri, params);

// Categories Values
export const createOrUpdateCategoriesValues = (params) => apiSauce.post(routes.updateOrCreateCategoryHasValues.uri, params);
export const getCategoriesValues = (params) => apiSauce.get(routes.getUserCategoryValues.uri, params);

// Upload Images
export const uploadImages = (params) => apiSauceFormData.post(routes.uploadImages.uri, params);
export const removeImage = (params) => apiSauce.post(routes.removeImage.uri, params);

// Files
export const getFiles = (params) => apiSauce.get(routes.getUserFiles.uri, params);

// Interests
export const saveCollabInterests = (params) => apiSauce.post(routes.syncUserCollabInterest.uri, params);
export const saveContentInterests = (params) => apiSauce.post(routes.syncUserContentInterest.uri, params);

// Ondato Verification
export const getOndatoLink = (params) => apiSauce.get(routes.getLink.uri, params);

// Users
export const getUsers = (params) => apiSauce.get(routes.getUsers.uri, params);
export const declineUser = (params) => apiSauce.post(routes.declineUser.uri, params);
export const approveUser = (params) => apiSauce.post(routes.approveUser.uri, params);
export const requestEdit = (params) => apiSauce.post(routes.requestEdit.uri, params);
export const getUserStats = (params) => apiSauce.get(routes.getUsersStat.uri, params);
export const getSavedProfiles = (params) => apiSauce.get(routes.getSavedProfiles.uri, params);
export const generateMailChangeEmail = (params) => apiSauce.post(routes.generateMailChangeEmail.uri, params);
export const updateEmail = (params) => apiSauce.post(routes.updateEmail.uri, params);
export const updateMyPassword = (params) => apiSauce.post(routes.updateMyPassword.uri, params);
export const deleteAccount = (params) => apiSauce.post(routes.deleteAccount.uri, params);
export const createUser = (params) => apiSauceFormData.post(routes.createUser.uri, params);
export const updateUser = (params) => apiSauceFormData.post(routes.updateUser.uri, params);
export const resendEmailChangeEmail = (params) => apiSauce.post(routes.resendEmailChangeEmail.uri, params);

// Collab
export const getCollabRequest = (params) => apiSauce.get(routes.getCollabRequest.uri, params);
export const getAllAcceptedCollabRequest = (params) => apiSauce.get(routes.getAllAcceptedCollabRequest.uri, params);
export const getUserAcceptedCollabRequest = (params) => apiSauce.get(routes.getUserAcceptedCollabRequest.uri, params);
export const createCollabRequest = (params) => apiSauce.post(routes.createCollabRequest.uri, params);
export const rejectCollabRequest = (params) => apiSauce.post(routes.declineCollabRequest.uri, params);
export const acceptCollabRequest = (params) => apiSauce.post(routes.approvedCollabRequest.uri, params);
export const cancelCollabRequest = (params) => apiSauce.post(routes.cancelCollabRequest.uri, params);

// Home Page
export const getUserList = (params) => apiSauce.get(routes.getUserList.uri, params);
export const getUnverifiedAccounts = (params) => apiSauce.get(routes.getUnverifiedAccounts.uri, params);

// User Preference
export const getUserPreference = (params) => apiSauce.get(routes.getUserPreference.uri, params);
export const updateOrCreateUserPreference = (params) => apiSauce.post(routes.updateOrCreateUserPreference.uri, params);

// Notifications
export const getNotifications = (params) => apiSauce.get(routes.getUserNotifications.uri, params);
// export const getCollabAcceptedNotifications = (params) => apiSauce.get(routes.getUserCollabAcceptedNotifications.uri, params);
export const markNotificationAsRead = (params) => apiSauce.post(routes.markNotificationAsRead.uri, params);
export const markAllNotificationAsRead = (params) => apiSauce.post(routes.markAllNotificationAsRead.uri, params);
export const getNotificationsCount = (params) => apiSauce.get(routes.getUserNotificationsCount.uri, params);

//Contact Us
export const contactUsMail = (params) => apiSauce.post(routes.contactUsMail.uri, params);

//Chat
export const getMessages = (params) => apiSauce.get(routes.getMessages.uri, params);
export const sendMessage = (params) => apiSauce.post(routes.sendMessage.uri, params);
export const getChatList = (params) => apiSauce.get(routes.getChatList.uri, params);
export const markMessagesAsRead = (params) => apiSauce.post(routes.markMessagesAsRead.uri, params);

//Broadcast Messages
export const getBroadcastMessages = (params) => apiSauce.get(routes.getBroadcastMessages.uri, params);
export const createBroadcastMessage = (params) => apiSauce.post(routes.createBroadcastMessage.uri, params);
export const getBroadcastMessageRecipients = (params) => apiSauce.get(routes.getBroadcastMessageRecipients.uri, params);

//Referral
export const sendReferralContactUsEmail = (params) => apiSauce.post(routes.sendReferralContactUsEmail.uri, params);

// Report Creator Feature
export const fetchReportedCreators = (params) => apiSauce.get(routes.reportedUsers.uri, params);
export const reportUser = (params) => apiSauce.post(routes.reportUser.uri, params);
export const banReportedUser = (reportedUserId) => apiSauce.post(route("banReportedUser", { reportedUserId }));
export const dismissReport = (reportedUserId) => apiSauce.post(route("dismissReportedUser", { reportedUserId }));
export const messageReportedUser = (reportedUserId, payload) =>
  apiSauce.post(route("messageReportedUser", { reportedUserId }), payload);

export default apiSauce;
